export default {
  buttonContrastColor: Styles.color.contrastBackground,
  points: 'crownPoints',
};
